<template>
    <!-- <div class="container mt-4 mb-4" v-if="isloading">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <p class="spinner-border"></p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <base-spinner :open="isloading"></base-spinner>
  
    <div class="container mt-4 mb-4" v-if="isloading">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <base-message
              v-if="!isloading"
              :servermessages="servermessages"
              ></base-message>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="site__body" v-if="!isloading">
      <!-- <div class="block-header block-header--has-breadcrumb block-header--has-title"> -->
        <div class="container">
          <div class="flex-container--breadcrumbs-selected-vehicle">
            <!-- <div class="flexbox-page-info-container"> -->
              <div class="flexbox-container--breadcrumbs" style="margin-bottom: 0px">
                <nav
                  class="breadcrumb block-header__breadcrumb"
                  aria-label="breadcrumb"
                >
                  <ol class="breadcrumb__list breadcrumb__list-product-detail">
                    <li
                      class="breadcrumb__spaceship-safe-area"
                      role="presentation"
                    ></li>
                    <li
                      class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first"
                    >
                      <router-link to="/home" class="breadcrumb__item-link">Home</router-link>
                    </li>
                    <li class="breadcrumb__item breadcrumb__item--parent">
                      <router-link to="/search-results" class="breadcrumb__item-link"
                        >Search Results</router-link>
                    </li>
                    <li
                      class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last"
                      aria-current="page"
                    >
                      <span class="breadcrumb__item-link"
                        >{{ product.desc }}</span
                      >
                    </li>
                  </ol>
                </nav>
              </div>
              <!-- <selected-vehicle></selected-vehicle> -->
              <base-selected-vehicle></base-selected-vehicle>
              <div class="block-space block-space--layout--divider-nl"></div>
            <!-- </div> -->
          </div>
        </div>
      <!-- </div> -->
  
  
      <div class="block-split block-split--has-sidebar" v-if="!isloading">
        <div class="container">
          <div class="block-split__row row no-gutters">
            <div class="block-split__item block-split__item-sidebar col-auto">
              <!-- <product-categories></product-categories>  -->
               <latest-products></latest-products> 
               
            </div> 
  
            <div class="block-split__item block-split__item-content col-auto">
              <div class="product product--layout--sidebar">
                <div class="product__body">
                  <div class="product__card product__card--one"></div>
                  <div class="product__card product__card--two"></div>
  
                  <partslink-card ref="col2Card" :product="product" :prod_desc="prod_desc"></partslink-card>
  
                  <div class="product__info">
                    <partslink-info ref="col3Card" :product="product"></partslink-info>
  
                    <div></div>
  
                    <!-- <shop-features></shop-features> -->
                  </div>
                  <!-- <detail-tabs :product="product" :reviews="reviews" :alternatives="alternatives"></detail-tabs> -->
                  <detail-tabs :tabs="tabs" :default-tab="defaultTab" :prod_desc="prod_desc" :attributes="attributes"></detail-tabs>
                </div>
              </div>
              <!-- <div class="block-space block-space--layout--divider-nl"></div> -->
              <div class="block-space block-space--layout--divider-thin"></div>
  
              <!-- <suggested-swiper></suggested-swiper> -->
            </div>
          </div>
        </div>
      </div>
  
      <div class="block-space block-space--layout--before-footer"></div>
    </div>
  </template>
  
  <script>
  import axiosvl from "../../../axios/axios-vl.js";
  import DetailTabs from "../productdetail/DetailTabs";
  import LatestProducts from "../productdetail/LatestProducts";
  // import AlternateProducts from "../productdetail/AlternateProducts";
  import PartslinkCard from "./PartslinkCard";
  // import ProductCategories from "./ProductCategories";
  import PartslinkInfo from "./PartslinkInfo";
  // import SelectedVehicle from "./SelectedVehicle";
  // import ShopFeatures from "./ShopFeatures";
  // import SuggestedProducts from "./SuggestedProducts";
  // import SuggestedSwiper from './SuggestedSwiper.vue';
  import CloudinaryApi from '../../../utilities/cloudinaryapi';
  import * as GCONST from '../../../constants.js';
  // import {scale} from "@cloudinary/base/actions/resize";
  // import Cloudinary from '../../../utilities/cloudinary';
  
  export default {
    props: {
      manufacturer: {
        type: String,
        required: true
      },
      partnumber: {
        type: String,
        required: true,
      },
    },
    name: "ProductDetail",
    components: {
      DetailTabs,
      LatestProducts,
      PartslinkCard,
      // ProductCategories,
      PartslinkInfo,
      // SelectedVehicle,
      // ShopFeatures,
      // AlternateProducts
      // SuggestedSwiper
    },
    data() {
      return {
        // product tabs
        defaultTab: '',
        product : {},
        lg_img: '',
        sm_img: '',
  
        attributes: [],
        tabs: [],
        prod_attr: [],
        prod_desc: '',
        
        isloading: false,
        serverstatus: '',
        servermessages: [],
  
        prevRoute: null,
      }
    },
    methods: {
      getCEAttributes() {
        this.isloading = true;
        this.tabs = [], this.attributes = [];
  
        axiosvl.post(this.$store.getters['api/get_ce_prod_attributes_uri'], {
            "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },
                "fields": {
                    // "HOSTURL": { "value": this.$store.getters.hosturl },
                    "LW3SFID": { "value": this.$store.getters.storefront },
                    "LW3MFR": { "value": this.manufacturer },
                    "LW3ITEMCD": { "value": this.partnumber },
                },   
            }
        })
        .then((response) => {
            for (const key in response.data.webroutine.lists.LS_PRODUCTATTRIBUTES.entries) {
                const obj = response.data.webroutine.lists.LS_PRODUCTATTRIBUTES.entries[key];
                this.attributes.push({
                    id: obj.LW3IATID,
                    sequence: obj.LW3IATSQ,
                    name: obj.LW3IATNM,
                    value: obj.LW3IATVL
                });
            }
  
            for (const key in response.data.webroutine.lists.LS_PRODUCTTABS.entries) {
                const obj = response.data.webroutine.lists.LS_PRODUCTTABS.entries[key];
                this.tabs.push({
                    index: obj.LW3IATTI,
                    name: obj.LW3IATNM,
                    content: obj.LW3IATVL
                });
            }
  
            // console.log(this.tabs);
  
            // this.tabs.push({
            //     index: 0,
            //     name: 'Description',
            //     content: ''
            // });
  
            if (this.tabs.length > 0) {
              this.defaultTab = this.tabs[0].name;
            }
  
            this.isloading = false;
  
        })
        .catch((error) => {
            console.log("error on CE Attribute - " + error);
            this.isloading = false;
        });
      },
      getProductDetails() {
        // console.log('called getProductDetails');
        this.isloading = true;
        this.product = {
          gallery: []
        };
        const wd_mdfgs = this.$store.getters.wd_mfgxs;
  
        axiosvl.post(this.$store.getters['api/product_details_uri'], {
            "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },
                "fields": {
                    "EHCUST": { "value": this.$store.getters.customer },
                    "EIMFGC": { "value": this.manufacturer },
                    "EIITMC": { "value": this.partnumber },
                },   
            }
        })
        .then((response) => {
            const fields = response.data.webroutine.fields;
            const lists = response.data.webroutine.lists;
            const DDTXT = lists.DDTXT;
            this.prod_desc = '';
            
            let imagegallery = [];
  
            if(fields.IMISVALID.value == 'N'){
              this.$router.push('/404');
              return;
            }
  
            DDTXT.entries.forEach(d => {
              this.prod_desc += d.DDTXT1 + d.DDTXT2 + d.DDTXT3 + d.DDTXT4 + d.DDTXT5 + d.DDTXT6 + d.DDTXT7 + d.DDTXT8 + d.DDTXT9 + d.DDTXT0;
            });
  
            // get cloudinary image
            const clApi = new CloudinaryApi;
            clApi.item_sku = fields.IXSITM.value;
            // clApi.item_sku = fields.IXSITM.value;
            clApi.manufacturer_code = fields.IMMFGC.value;
  
            // large image
            clApi.vlWidgetGallery(GCONST.CL_ITEM_GALLERY).then(imgGallery => {
              if(imgGallery){
                // sort the array by sequence
                imgGallery.sort((a,b) => (a.sequence > b.sequence) ? 1 : ((b.sequence > a.sequence) ? -1 : 0));
                imagegallery = imgGallery;
              }
            });
            const xref_mfg_desc = wd_mdfgs.find(mfg => mfg.MFG_CODE == fields.XRMFGC.value);
            setTimeout(() => {
              this.product = {
                sku: fields.IMITMC.value,
                desc: fields.IMDESC.value,
                item_description: fields.IMDESC.value,
                manufacturer: fields.IMMFGC.value,
                manufacturername: fields.MCNAME.value,
                location: fields.CMDLOC.value,
                // Based on Nic's comments on Issue #32 - Prices for a part in DMS depend on the Customer signed in (EHCUST) (assumptions made that some field names are incorrect)
                  // Price: EIECP
                  // Core Price: EICORP
                  // List Price: EILISTP (if setup for the customer)
                price: fields.EIEXCP.value,
                coreprice: fields.EICORP.value,
                listprice: fields.EILSTP.value,
                XRITMC: fields.XRITMC.value,
                XRMFGC: fields.XRMFGC.value,
                xref_mfg_desc: (fields.XRMFGC.value != '') ? xref_mfg_desc.MFG_DESC : '',
                IMIGSA: fields.IMIGSA.value,
                IMISVALID: fields.IMISVALID.value,
                stockquantity: (this.$store.getters.customerIndicator == 'B') ? fields.QTYAVL.value : fields.TOTOH.value,
                // !NC! - Data below will be hardcoded for now until we can get clarification on where to pick them up
                // fittingdesc: 'Part Fit for 2018 Chevrolet Truck Silverado 1500 LT 4WD 5.3L (x)',
                gallery: imagegallery
              };

              this.$refs.col3Card.promotion_text();
              this.$refs.col3Card.searchPartsLink();

              this.isloading = false;
            }, 2000);
  
        })
        .catch((error) => {
            console.log("error - " + error);
            this.isloading = false;
        });
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.name;
      })
    },
    watch: {
      manufacturer() {
        // this.getProductDetails();
        this.getCEAttributes();
      },
      partnumber() {
        this.getProductDetails();
        this.getCEAttributes();
      },
    },
    beforeCreate() {
      
    },
    created() {
      this.$ga.page({
          page: this.$route.fullPath,
          title: this.$route.name,
      });
      this.getProductDetails();
      this.getCEAttributes();
    },
  
  };
  </script>
  